"use client";

import "@ant-design/v5-patch-for-react-19";

import { RightArrowIcon } from "@/assets/icons";
import { ThreadListItem } from "@/component/ThreadListItem";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { threadStore } from "@/store/thread";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import Link from "next/link";
import { useEffect } from "react";
import { ThreadListSkeletonGrid } from "./ThreadListSkeletonGrid";

export const RecentProjectsSection = observer(() => {
  const threads = threadStore.threads;
  const loading = threadStore.threadsLoading;
  const { is2xl, isXl, isLg, isMd, isSm } = useBreakpoints();

  let visibleCount = 2;
  if (is2xl) visibleCount = 5;
  else if (isXl) visibleCount = 4;
  else if (isLg || isMd) visibleCount = 3;
  else if (isSm) visibleCount = 2;

  useEffect(() => {
    threadStore.fetchThreads({ limit: 10 });
  }, []);

  if (loading && threads.length === 0) {
    return (
      <section>
        <ThreadListSkeletonGrid count={visibleCount} />
      </section>
    );
  }

  if (threads.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <h2 className="text-text-primary font-bold text-xl">Recent projects</h2>
        <Link href="/thread">
          <Button
            className="text-text-primary font-medium text-base pr-0! hover:bg-transparent!"
            type="text"
            icon={<RightArrowIcon className="w-4 h-4" />}
            iconPosition="end"
          >
            See all
          </Button>
        </Link>
      </div>
      <div className="grid-thread">
        {threads.slice(0, visibleCount).map((thread) => (
          <Link href={`/thread/${thread.id}`} key={thread.id}>
            <ThreadListItem thread={thread} />
          </Link>
        ))}
      </div>
    </section>
  );
});
